// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3z8Ol","fileBtn":"File_fileBtn__2_EAp","closeBtn":"File_closeBtn__2v1u4","fileSelected":"File_fileSelected__9Hzx1","disabled":"File_disabled__ndkPg"};